define(
  'app/views/categories_product_list_view',['app/setup',
    'app/views/pagination__view'],
  function (takhfifan) {

    takhfifan.CategoriesProductListView = takhfifan.BaseView.extend({

      initialize: function (options) {
        var _this = this;
        this.pagesCount = options.pagesCount;
        this.page = options.page;

        this.initiatePagination();

        this.$dealWarpper = $('.tkh-os-tag-trigger');
        takhfifan.eventHub.on('category:loadPage', function (options) {
          _this.$dealWarpper.addClass('loading-view');
          var varName = 'page';
          var path = _this.removePageNumber(varName);
          window.location.replace(
            location.protocol + '//' +
            location.host +
            path +
            '/'+varName+'/' + (options.page + 1));
        });
      },

      removePageNumber: function (varName) {
        var requestPath = location.pathname;
        var editedRequestPath = requestPath;
        var varNameStartPosition = requestPath.indexOf(varName);
        if (varNameStartPosition !== -1) {
          editedRequestPath = requestPath.substr(0, varNameStartPosition-1);
        }
        return editedRequestPath;
      },

      initiatePagination: function () {
        var pageCount = this.getPageCount();
        if (pageCount > 0) {
          this.paginationView = new takhfifan.Pagination({
            el: $('.tkh-pagination'),
            count: pageCount,
            currentPage: this.page - 1,//pagination plugin start form 0
            clickEvent: "category:loadPage",
            hideAtStart: false
          });
          this.paginationView.$el.show();
        }
      },

      getPageCount: function () {
        var pageCount = this.pagesCount;
        if (!this.pagesCount || this.pagesCount === 0) {
          takhfifan.eventHub.trigger('message:show', {
            msg: i18n.t('connection_error'),
            type: 'error'
          });
        }
        return pageCount;
      },
    });
  });
